"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  type: 1,
  path: '/sms-agent-management',
  component: _layout.default,
  redirect: '/sms-agent-management/agent-management',
  name: '',
  meta: {
    title: 'agentManagement',
    icon: 'g-agent'
  },
  children: [{
    type: 2,
    path: 'agent-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-agent-management/agent-management'));
      });
    },
    name: 'agent:view',
    meta: {
      title: 'agentManagement'
    },
    children: [{
      path: 'add',
      name: 'agent:add',
      hidden: true
    }, {
      path: 'update',
      name: 'agent:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'agent:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'agent:export',
      hidden: true
    }, {
      path: 'updates',
      name: 'agent:costUpdates',
      hidden: true
    }, {
      path: 'agentMenuLimitUpdate',
      name: 'agent:menuLimitUpdate',
      hidden: true
    }, {
      path: 'resetPassword',
      name: 'agent:resetPassword',
      hidden: true
    }, {
      path: 'add',
      name: 'agent:rechargeOrderAdd',
      hidden: true
    }, {
      path: 'key',
      name: 'agent:google:key',
      hidden: true
    }, {
      path: 'forceLogoff',
      name: 'agent:forceLogoff',
      hidden: true
    }]
  }, {
    type: 3,
    path: "agent-cost",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-agent-management/agent-cost"));
      });
    },
    name: "agentCost:view",
    hidden: true,
    props: true,
    meta: {
      title: "agentCost",
      noCache: true
    },
    children: [{
      path: 'add',
      name: 'agentCost:add',
      hidden: true
    }, {
      path: 'update',
      name: 'agentCost:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'agentCost:delete',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'agent-Permission',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-agent-management/agent-permission'));
      });
    },
    name: 'agentMenu:view',
    meta: {
      title: 'agentPermission'
    },
    children: [{
      path: 'add',
      name: 'agentMenu:add',
      hidden: true
    }, {
      path: 'update',
      name: 'agentMenu:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'agentMenu:delete',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'agent-settings',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-agent-management/agent-settings'));
      });
    },
    name: 'agentSystemConfig:view',
    meta: {
      title: 'agentSettings'
    },
    children: [{
      path: 'approve',
      name: 'agentSystemConfig:approve',
      hidden: true
    }]
  }]
};
var _default = orderRouter;
exports.default = _default;